import type { ConfigurationItem } from './models';

export const ENVIRONMENT_CONFIGURATION_KEY = 'environment';
export type NavigationLayout = 'top' | 'left' | 'combined';
export type NavigationMode = 'auto' | 'open' | 'closed';

export interface EnvironmentConfiguration {
  [key: string]: unknown;
  version: 1;
  navigation: {
    [key: string]: unknown;
    layout?: NavigationLayout;
    mode?: NavigationMode;
  };
}

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/** The client owns the schema; absent or invalid fields use system defaults without a write. */
export const parseEnvironmentConfiguration = (
  configuration: ConfigurationItem[]
): EnvironmentConfiguration => {
  const value = configuration.find((item) => item.key === ENVIRONMENT_CONFIGURATION_KEY)?.value;
  try {
    const parsed: unknown = value ? JSON.parse(value) : undefined;
    if (!isObject(parsed) || parsed.version !== 1) return { version: 1, navigation: {} };
    const navigation = isObject(parsed.navigation) ? parsed.navigation : {};
    return {
      ...parsed,
      version: 1,
      navigation: {
        ...navigation,
        layout:
          navigation.layout === 'top' ||
          navigation.layout === 'left' ||
          navigation.layout === 'combined'
            ? navigation.layout
            : undefined,
        mode:
          navigation.mode === 'auto' || navigation.mode === 'open' || navigation.mode === 'closed'
            ? navigation.mode
            : undefined
      }
    };
  } catch {
    return { version: 1, navigation: {} };
  }
};

export const getEnvironmentNavigation = (
  configuration: EnvironmentConfiguration,
  isSuperAdmin: boolean
) => ({
  layout: configuration.navigation.layout ?? (isSuperAdmin ? 'left' : 'top'),
  mode: configuration.navigation.mode ?? 'auto'
});
